export default {
      id: "soc-fb-usage",
      viewBox: "0 0 21 20",
      url: "/" + "assets/sprite.svg#soc-fb",
      toString: function () {
        return this.url;
      }
    }